export default __webpack_public_path__ + "static/media/ab-icon-active.9947910f.svg";